
// function read_cookie(key)
// {
//     var result;
//     return (result = new RegExp('(?:^|; )' + encodeURIComponent(key) + '=([^;]*)').exec(document.cookie)) ? (result[1]) : null;
// }


window.read_cookie = function(cookie) {
  var cookies;
  c = document.cookie.split('; ');
  cookies = {};
  for(i=c.length-1; i>=0; i--){
     cook = c[i].split('=');
     if (cookies[cook[0]] == undefined) {
       cookies[cook[0]] = cook[1];
     }
  }
  
  return cookies[cookie];
}

// function read_cookie(name) {
//   const value = `; ${document.cookie}`;
//   const parts = value.split(`; ${name}=`);
//   if (parts.length === 2) return parts.pop().split(';').shift();
// }



function swap_diseasestates(diseasestate, cookie_write=true) {


    if(diseasestate)
    $('.diseasestatebutton').removeClass('psych');
    $('.diseasestatebutton').removeClass('respi');
    $('.diseasestatebutton').removeClass('neuro');
    $('.diseasestatebutton').removeClass('fypatients');
    $('.diseasestatebutton').removeClass('pophealth');

    $('.themed').removeClass('psych');
    $('.themed').removeClass('respi');
    $('.themed').removeClass('neuro');
    $('.themed').removeClass('fypatients');
    $('.themed').removeClass('pophealth');

    $(".ed-programs").hide();
    $(".resource-item").hide();
    $('#tparea').val(diseasestate)

    var diseasestatestring = "?disease_state=" + diseasestate;

          $('.regionlink').each(function () {
              var value = $(this).attr('href');


                  if (value.includes("?")) {
                      value = value.substring(0, value.indexOf('?'))

                  }
                  $(this).attr('href', value +diseasestatestring);
                  value = $(this).attr('href');


          })
    if (diseasestate == "psychiatry") {
        $('.diseasestatebutton[value=' + diseasestate + ']').addClass('psych');
        $('.themed').addClass('psych')

        $('.usmap').attr('class', 'usmap psychiatry')
        $("#psychprograms").show()
        $(".psychresources").show()

    } else if (diseasestate == "respiratory") {
            $('.diseasestatebutton[value='+ diseasestate + ']').addClass('respi');
            $('.themed').addClass('respi')
            $('.usmap').attr('class', 'usmap respiratory')
        $("#respiprograms").show()
        $(".respiresources").show()


    } else if (diseasestate == "fypatients") {
        $('.diseasestatebutton[value='+ diseasestate + ']').addClass('fypatients');
        $('.themed').addClass('fypatients')
    $(".fypatientsresources").show()


    }
 else if (diseasestate == "pophealth") {
    $('.diseasestatebutton[value='+ diseasestate + ']').addClass('pophealth');
    $('.themed').addClass('pophealth')
$(".pophealthresources").show()


}
    else {
        $('.diseasestatebutton[value=' + diseasestate + ']').addClass('neuro');
        $('.themed').addClass('neuro')

        $('.usmap').attr('class', 'usmap neurology')
        $("#neuroprograms").show()
        $(".neuroresources").show()

    }
          // if (cookie_write) {
            document.cookie = "tparea" + "=" + escape(diseasestate) + ";path=/";

          // }
}

$(document).on('turbolinks:load', function () {
    
    // $('.regionlink').each(function () {
    //     var value = $(this).attr('href');
    //     var diseasestate = $('.diseasestatebutton.selected').val();
    //     $(this).attr('href', value + "?disease_state=" + diseasestate);
    //
    // })
     var map_div = document.getElementById('map-click');

    if (read_cookie("tparea")) {
         if(map_div===null ){
            swap_diseasestates(read_cookie("tparea"), false);
         } else {
            map_div.style.pointerEvents = 'none';
        }
    } else if (map_div){
        map_div.style.pointerEvents = 'none';
    }
    

    if (read_cookie("confirmed")) {
      $('.popup-container2').hide();

    }
    if (!read_cookie("dismissedbubble")) {
        document.cookie = "dismissedbubble= true;";
        setTimeout(function() {
            $(".bubble-container").show();
        }, 3000);
    }

    if (read_cookie("previousUrl") && read_cookie("previousUrl").includes("resources") && read_cookie("tparea") && read_cookie("tparea").includes("fypatients")  && !window.location.href.includes("resources") && !window.location.href.includes("resourcepages")  ) {
        document.cookie = "tparea" + "=" + escape("neurology") + ";path=/";
       
    }
    if (read_cookie("previousUrl") && read_cookie("previousUrl").includes("resources") && read_cookie("tparea") && read_cookie("tparea").includes("pophealth") && !window.location.href.includes("resources") && !window.location.href.includes("resourcepages")   ) {
        document.cookie = "tparea" + "=" + escape("neurology") + ";path=/";
        
    }
    document.cookie = "previousUrl" + "=" + document.referrer + ";";


    $('.diseasestatebutton').click(function (e) {


        var diseasestate = $(this).val();
        swap_diseasestates(diseasestate);

    });
    $('.unsubscribe-button').on('click', function () {
        $('.unsubscribe-popup').hide()
    })

    $('#hcp-confirm-form button[type=submit]').click(function (e) {
        e.preventDefault();
        if ($('#hcp-confirm-form')[0].checkValidity()) {
            $('.popup-container2').addClass('animate__zoomOut');
             var now = new Date();
             now.setTime(now.getTime() + 1 * 3600 * 1000);
             document.cookie = "confirmed" + "=" + escape("true") + ";";
          //   document.cookie = "tparea" + "=" + escape("neurology") + ";";
        

            setTimeout(function () {
                $('.popup-container2').hide();
            }, 1000)
        } else {
            $('#hcp-confirm-form')[0].reportValidity()
            return false;
        }
    })
});
